export const Login = '/api/admin/user/user_login' /**用户登录**/
export const editUser = '/api/admin/user/update' /**用户编辑**/
export const editUserPassword = '/api/admin/user/upd_self' /**用户修改密码**/
export const validatePassword = '/api/admin/user/validate_password' /**校验密码复杂度**/
export const pwdStatus = '/api/admin/user/pwd_status' /**查询密码状态**/
export const pwdPolicy = '/api/admin/user/pwd_policy' /**获取密码策略**/
export const getAllUserList = '/api/admin/user/pageList' /**用户修改密码**/
export const userSave = '/api/admin/user/save' /**新增用户**/
export const deleteSave = '/api/admin/user/update' /**删除用户**/
export const userReset = '/api/admin/user/userReset' /**重置用户微信企业userid**/
export const listRole = '/api/admin/rol/list' /**查询角色列表**/
export const addRole = '/api/admin/rol/insert' /**新增角色**/
export const editRole = '/api/admin/rol/update' /**修改角色**/
export const deleteRole = '/api/admin/rol/delete' /**删除角色**/
export const editUserRole = '/api/admin/rol/auth/update' /**修改角色权限**/
export const userRole = '/api/admin/user/user_role/' /**查询用户角色**/
export const addUserRole = '/api/admin/user/role/insert' /**查询用户角色**/
export const deleteUserRole = '/api/admin/user/role/delete/' /**删除用户角色**/
export const getUserByRole = '/api/admin/user/role/getUserByRole/' /**根据角色查询用户**/
export const addItemCheekByPmiId = '/api/admin/user/item/check/insertItemCheekByPmiId/' /**新增保养计划验收**/
export const addItemByPmiId = '/api/admin/user/item/insertItemByPmiId/' /**新增保养计划推送**/
export const getUserItemByPmiId = '/api/admin/user/item/getUserItemByPmiId/' /**根据Id查询保养计划**/
export const getUserItemCheckByPmiId = '/api/admin/user/item/check/getUserItemCheckByPmiId/' /**根据Id查询保养计划推送用户**/
export const depart_tree = '/api/admin/depart/depart_tree' /**用户工厂区域级联**/
export const departTree = '/api/admin/depart/departTree' /**角色工厂区域级联**/
export const getAllRole = '/api/admin/rol/All' /**查询所有角色**/
export const SearchUser = '/api/user/users' /**查询用户列表**/
export const SearchRole = '/api/role/roles' /**查询用户列表**/
export const getAllRoleAuth = '/api/admin/rol/auth/ALL' /**查询角色拥有权限**/
export const getAllAuth = '/api/admin/authority/getAuthorityTree' /**查询所有权限**/
export const getAllShift = '/api/base/shift/pageList' /**查询所有班次**/
export const shiftList = '/api/base/shift/list' /**查询班次**/
export const addShift = '/api/base/shift/save' /**新增班次**/
export const editShift = '/api/base/shift/update' /**修改班次**/
export const delShift = '/api/base/shift/del' /**删除班次**/
export const getAllFactory = '/api/base/factory/list' /**查询所有工厂**/
export const getAndonTypeRuleAuth = '/api/admin/andon_type_rule_auth/list' /**查询安灯类型角色权限**/
export const addAndonTypeRuleAuth = '/api/admin/andon_type_rule_auth/save' /**增加类型角色权限**/
export const delAndonTypeRuleAuth = '/api/admin/andon_type_rule_auth/del' /**删除安灯类型角色权限**/
export const getWorkShopList = '/api/base/work_shop/list' /**根据工厂编码查询车间**/
export const getSectionList = '/api/base/section/list' /**根据车间编码查询工段**/
export const getLineList = '/api/base/line/list' /**根据车间编码查询工段**/
export const lineList = '/api/base/line/lineList' /**根据工厂编码查询产线**/
export const addFactory = '/api/base/factory/save' /**新增工厂**/
export const editFactory = '/api/base/factory/edit' /**修改工厂**/
export const addWorkShop = '/api/base/work_shop/save' /**新增车间**/
export const editWorkShop = '/api/base/work_shop/edit' /**修改车间**/
export const delWorkShop = '/api/base/work_shop/del/' /**删除车间**/
export const addsection = '/api/base/section/save' /**新增工段**/
export const editsection = '/api/base/section/edit' /**修改工段**/
export const delSection = '/api/base/section/del/' /**删除工段**/
export const addline = '/api/base/line/save' /**新增产线**/
export const editline = '/api/base/line/edit' /**修改产线**/
export const delLine = '/api/base/line/del/' /**删除产线**/
export const getAllAndonRule = '/api/andon_rule/pageList' /**查询所有安灯规则**/
export const addAndonRule = '/api/andon_rule/save' /**新增安灯规则**/
export const editAndonRule = '/api/andon_rule/edit' /**编辑安灯规则**/
export const deteleAndonRule = '/api/andon_rule/delete/' /**删除安灯规则**/
export const getAndonRule = '/api/andon_rule/getAndonRule' /**查询所有安灯种类**/
export const getAllAndonOrder = '/api/andon_order/list' /**查询所有安灯工单**/
export const andonOrderList = '/api/andon_order/andonOrderList' /**根据待验收状态查询所有安灯**/
export const editAndonOrder = '/api/andon_order/edit' /**编辑安灯工单**/
export const deleteAndonOrder = '/api/andon_order/del/' /**删除安灯工单**/
export const getAndonOrderLog = '/api/andon_order/log' /**根据安灯编号查询安灯日志**/
export const getAndonContent = '/api/andon_rule/getAndonContent' /**查询安灯种类**/
export const addAndonContent = '/api/andon_content/save' /**新增安灯种类**/
export const editAndonContent = '/api/andon_content/update' /**编辑安灯种类**/
export const deleteAndonContent = '/api/andon_content/del/' /**删除安灯种类**/
export const andonContentList = '/api/andon_content/list' /**根据工厂,安灯类型查询安灯种类**/
export const getAlldevice = '/api/base/device/pageList' /**查询所有设备**/
export const addDevice = '/api/base/device/save' /**新增设备**/
export const editDevice = '/api/base/device/edit' /**编辑设备**/
export const deleteDevice = '/api/base/device/del' /**删除设备**/
export const getAllDailyCheckOrder = '/api/daily_check_order/pageList' /**查询所有设备点检**/
export const deleteDailyCheckOrder = '/api/daily_check_order/del' /**查询所有设备点检**/
export const getAndonNotifyRule = '/api/andon_notify_rule/list/' /**安灯规则角色通知**/
export const deleteAndonRuleRole = '/api/andon_rule_role/del' /**删除安灯规则角色通知**/
export const addAndonRuleRole = '/api/andon_rule_role/save' /**新增安灯规则角色通知**/
export const getDeviceFileDevCode = '/api/base/device_file/list' /**根据工单编号查询点检文件**/
export const addDeviceFile = '/api/base/device_file/save' /**新增点检文件**/
export const editDeviceFile = '/api/base/device_file/edit' /**编辑点检文件**/
export const deleteDeviceFile = '/api/base/device_file/del' /**删除点检文件**/
export const getDailyCheckItemDevCode = '/api/daily_check_item/list' /**根据工单编号查询日常点检项**/
export const addDailyCheckItem = '/api/daily_check_item/save' /**根据工单编号查询日常点检项**/
export const editDailyCheckItem = '/api/daily_check_item/edit' /**根据工单编号查询日常点检项**/
export const deleteDailyCheckItem = '/api/daily_check_item/del' /**根据工单编号查询日常点检项**/
export const getPlanMantainItemDevCode = '/api/plan_mantain_item/list' /**根据工单编号查询计划保养项**/
export const addPlanMantainItem = '/api/plan_mantain_item/save' /**新增计划保养项**/
export const editPlanMantainItem = '/api/plan_mantain_item/edit' /**编辑计划保养项**/
export const deletePlanMantainItem = '/api/plan_mantain_item/del' /**删除计划保养项**/
export const getPmiRespTypes = '/api/plan_mantain_item/getPmiRespTypes' /**获取计划保养方法枚举**/
export const getPlanMaintainOrder = '/api/admin/plan_maintain_order/pageList' /**计划工单列表**/
export const addPlanMaintainOrder = '/api/admin/plan_maintain_order/save' /**新增计划工单**/
export const editPlanMaintainOrder = '/api/admin/plan_maintain_order/edit' /**编辑计划工单列表**/
export const delPlanMaintainOrder = '/api/admin/plan_maintain_order/del' /**删除计划工单列表**/
export const planMaintainOrderList = '/api/admin/plan_maintain_order/planMaintainOrderList' /**查询所有计划保养工单**/
export const getPlanMaintainOrderPmoNo = '/api/admin/plan_maintain_order/getPlanMaintainOrderPmoNo' /**根据计划工单编号查询计划工单**/
export const getPlanMaintainLogPmoNo = '/api/plan_maintain_log/list' /**保养工单号查询计划工单**/
export const getAndonOrderLogAndonCode = '/api/andon_order/log/andonOrderLog' /**根据安灯编号查询安灯日志**/
export const getDacklogDcoId = '/api/daily_check_log/list' /**根据点检编号查询点检日志**/
export const getAllAndonType = '/api/andon_type/list' /**查询所有安灯类型**/
export const getRoleList = '/api/admin/rol/list' /**查询所有角色类型**/
export const addAndonContentInsert = '/api/andon_content/insert' /**查询所有角色类型**/
export const delAndonContent = '/api/andon_content/del/' /**删除安灯规则**/
export const getAndonContentOne = '/api/andon_content/get' /**获取安灯规则**/
export const getAndonRuleNext = '/api/andon_rule/next_rule/next/' /**获取安灯规则**/
export const getPlanMainOrderItemPmoNo = '/api/plan_maintain_order_item/list' /**根据计划编号查询计划保养项**/
export const getDeviceOperationLogDevCode = '/api/base/device_operation_log/list' /**根据设备编号查询设备操作日志**/
export const exportRole = '/api/admin/rol/export_role' /**角色导出**/
export const exportUser = '/api/admin/user/export_user' /**用户导出**/
export const exportShift = '/api/base/shift/export_shift' /**用户导出**/
export const exportDepart = '/api/admin/depart/export_depart' /**用户导出**/
export const exportDevice = '/api/base/device/export_device' /**设备导出**/
export const exportDailyCheckOrder = '/api/daily_check_order/export_daily_check_order' /**设备点检导出**/
export const exportPlanMaintainOrder = '/api/admin/plan_maintain_order/export_plan_maintain_order' /**计划保养导出**/
export const exportAndonRule = '/api/andon_rule/export_andon_rule' /**安灯规则导出**/
export const exportAndonOrder = '/api/andon_order/export_andon_order' /**安灯工单导出**/
export const exportAndonContent = '/api/andon_rule/export_andon_content' /**安灯工单导出**/
export const getAndonOrderCheckAndonCode = '/api/andon_order_check/andonOrderCheck' /**安灯工单导出**/
export const getAndonRuleAcCode = '/api/andon_rule/getAndonRuleAcCode' /**根据安灯种类编码查询安灯规则**/
export const getAndonOrderResp = '/api/andon_order/getAndonOrderResp' /**安灯工单详情页面基础信息**/
export const queryUserRoles = '/api/admin/user/queryUserRoles' /**根据用户角色查询工厂**/
export const changeFactoryLogin = '/api/admin/user/change_factory_login' /**切换工厂更新token**/
export const queryUserFactorys = '/api/admin/user/queryUserFactorys' /**查询用户工厂**/
export const editUserInfo = '/api/admin/user/updateUserInfo' /**个人中心修改用户信息**/
export const findUserById = '/api/admin/user/findUserById' /**个人中心查询用户信息**/
export const findUserByAccount = '/api/admin/user/findUserByAccount' /**根据员工工号查询用户**/
export const userTemplate = '/api/admin/user/userTemplate' /**导出用户模板**/
export const userImport = '/api/admin/user/userImport' /**批量导入用户**/
export const userTestExport = '/api/admin/user/export' /**批量导入用户**/
export const deviceTemplate = '/api/base/device/deviceTemplate' /**设备导入模板**/
export const deviceImport = '/api/base/device/deviceImport' /**批量导入设备**/
export const planMaintainTemplate = '/api/plan_mantain_item/planMaintainTemplate' /**计划保养导入模板**/
export const planMaintainImport = '/api/plan_mantain_item/planMaintainImport' /**批量导入计划保养**/
export const dailyCheckItemTemplate = '/api/daily_check_item/dailyCheckItemTemplate' /**点检项导入模板**/
export const dailyCheckItemImport = '/api/daily_check_item/dailyCheckItemImport' /**批量导入点检项**/
export const enumTypePageList = '/api/enum_type/pageList' /**文件类型分页查询**/
export const enumTypelist = '/api/enum_type/list' /**文件类型分页查询**/
export const addEnumType = '/api/enum_type/save' /**新增文件类型**/
export const editEnumType = '/api/enum_type/edit' /**编辑文件类型**/
export const delEnumType = '/api/enum_type/del' /**删除文件类型**/
export const queryDevCode = '/api/base/device/queryDevCode' /**删除文件类型**/
export const getAllRepairExp = '/api/repair_exp/pageList' /**历史经验分页查询**/
export const getRepairExpDevCode = '/api/repair_exp/list' /**根据设备编号查询历史经验**/
export const addRepairExp = '/api/repair_exp/save' /**新增历史经验**/
export const editRepairExp = '/api/repair_exp/edit' /**编辑历史经验**/
export const deleteRepairExp = '/api/repair_exp/del' /**删除历史经验**/
export const getAllFaultCode = '/api/fault_code/pageList' /**故障代码分页查询**/
export const getFaultCodeDevCode = '/api/fault_code/list' /**根据设备编号查询历史经验**/
export const addFaultCode = '/api/fault_code/save' /**新增故障代码**/
export const editFaultCode = '/api/fault_code/edit' /**编辑故障代码**/
export const deleteFaultCode = '/api/fault_code/del' /**删除故障代码**/
export const faultCodeTree = '/api/fault_code/faultCodeTree' /**故障代码树状图**/
export const getAndonRuleTrigger = '/api/andon_rule/getAndonRuleTrigger' /**根据当前工厂和安灯种类查询规则**/
export const deviceInfoList = '/api/base/device/list' /**查询工厂下所有设备**/
export const getDeviceInfoDevCode = '/api/base/device/getDeviceInfoDevCode' /**根据设备编码查询设备信息**/
export const getAllToolingClassify = '/api/admin/tooling_classify/pageList' /**工装分类分页查询**/
export const toolingClassifyList = '/api/admin/tooling_classify/list' /**查询所有工装分类**/
export const addToolingClassify = '/api/admin/tooling_classify/save' /**新增工装分类**/
export const editToolingClassify = '/api/admin/tooling_classify/edit' /**编辑工装分类**/
export const deleteToolingClassify = '/api/admin/tooling_classify/del' /**删除工装分类**/
export const getAllToolingInfo = '/api/admin/tooling/pageList' /**工装清单分页查询**/
export const toolingInfoList = '/api/admin/tooling/list' /**工装清单分页查询**/
export const addToolingInfo = '/api/admin/tooling/save' /**新增工装清单**/
export const editToolingInfo = '/api/admin/tooling/edit' /**编辑工装清单**/
export const deleteToolingInfo = '/api/admin/tooling/del' /**删除工装清单**/
export const getToolingCode = '/api/admin/tooling/getToolingCode' /**根据工装编码查询工装详情**/
export const getToolingClassifyList = '/api/admin/tooling/getToolingClassifyList' /**根据工装分类id查询**/
export const toolingTemplate = '/api/admin/tooling/toolingTemplate' /**工装导入模板**/
export const toolingImport = '/api/admin/tooling/toolingImport' /**批量导入工装**/
export const exportToolingInfo = '/api/admin/tooling/export_tooling_info' /**工装导出**/
export const unitList = '/api/admin/spare_part_unit/list' /**查询所有单位分类**/
export const addToolingUse = '/api/admin/tooling_use/save' /**管理端工装领用**/
export const getUseRecordToolingTiId = '/api/admin/tooling_use/getUseRecordToolingTiId' /**管理端工装领用**/
export const exportToolingUseRecord = '/api/admin/tooling_use/export_tooling_use_record' /**工装领用导出**/
export const addToolingRevert = '/api/admin/tooling_revert/save' /**管理端工装归还**/
export const getRevertRecordToolingTiId = '/api/admin/tooling_revert/getRevertRecordToolingTiId' /**管理端工装归还**/
export const exportRevertRecordTooling = '/api/admin/tooling_revert/export_revert_record_tooling' /**工装归还导出**/
export const getAllPartClassify = '/api/admin/spare_part_classify/pageList' /**备件分类分页查询**/
export const partClassifyList = '/api/admin/spare_part_classify/list' /**查询备件分类**/
export const addPartClassify = '/api/admin/spare_part_classify/save' /**新增备件分类**/
export const editPartClassify = '/api/admin/spare_part_classify/edit' /**编辑备件分类**/
export const deletePartClassify = '/api/admin/spare_part_classify/del' /**删除备件分类**/
export const getAllSparePart = '/api/admin/spare_part/pageList' /**设备备件台账分页查询**/
export const sparePartInfoList = '/api/admin/spare_part/list' /**查询所有设备备件台账**/
export const queryByPartInfoSpCode = '/api/admin/spare_part/queryByPartInfoSpCode' /**根据备件编码查询**/
export const addSparePartInfo = '/api/admin/spare_part/save' /**新增设备备件台账**/
export const editSparePartInfo = '/api/admin/spare_part/edit' /**编辑设备备件台账**/
export const deleteSparePartInfo = '/api/admin/spare_part/del' /**删除设备备件台账**/
export const getSparePartInfoSpCode = '/api/admin/spare_part/getSparePartInfoSpCode' /**根据备件编码查询备件详情**/
export const sparePartInfoTemplate = '/api/admin/spare_part/sparePartInfoTemplate' /**备件导入模板**/
export const sparePartInfoImport = '/api/admin/spare_part/sparePartInfoImport' /**批量导入备件**/
export const exportSparePartInfo = '/api/admin/spare_part/export_sparePart_info' /**备件导出**/
export const getAllPartStoreHouse = '/api/admin/spare_part_storehouse/pageList' /**备件仓库分页查询**/
export const partStoreHouseList = '/api/admin/spare_part_storehouse/list' /**查询备件仓库**/
export const addPartStoreHouse = '/api/admin/spare_part_storehouse/save' /**新增备件仓库**/
export const editPartStoreHouse = '/api/admin/spare_part_storehouse/edit' /**编辑备件仓库**/
export const deletePartStoreHouse = '/api/admin/spare_part_storehouse/del' /**删除备件仓库**/
export const exportPartStoreHouse = '/api/admin/spare_part_storehouse/export_part_store_house' /**仓库导出**/
export const getAllPartStock = '/api/admin/spare_part_stock/pageList' /**库存分页查询**/
export const getAllPartStockStrCode = '/api/admin/spare_part_stock/pageStrCodeList' /**根据仓库编码分页查询**/
export const partStockList = '/api/admin/spare_part_stock/list' /**查询所有库存**/
export const queryAmount = '/api/admin/spare_part_stock/queryAmount' /**根据库位编码查询当前库存**/
export const sparePartLibrary = '/api/admin/spare_part_stock/sparePartLibrary' /**备件出入库查询**/
export const addPartStock = '/api/admin/spare_part_stock/save' /**新增库存**/
export const editPartStock = '/api/admin/spare_part_stock/edit' /**编辑库存**/
export const deletePartStock = '/api/admin/spare_part_stock/del' /**删除库存**/
export const userList = '/api/admin/user/userList' /**查询所有用户**/
export const tooLingClassifyTree = '/api/admin/tooling_classify/tooLingClassifyTree' /**工装分类树状图**/
export const partClassifyTree = '/api/admin/spare_part_classify/partClassifyTree' /**备件分类树状图**/
export const getAllPartPurchaseOrder = '/api/admin/spare_part/purchase_order/pageList' /**入库信息分页查询**/
export const addPartPurchaseOrder = '/api/admin/spare_part/purchase_order/save' /**备件入库**/
export const deletePartPurchaseOrder = '/api/admin/spare_part/purchase_order/del' /**删除备件入库**/
export const queryPartInfoLogs = '/api/admin/spare_part/purchase_order/queryPartInfoLogs' /**备件入库日志记录**/
export const exportPartPurchase = '/api/admin/spare_part/purchase_order/export_part_purchase' /**备件入库日志记录**/
export const getAllPartDeliveryOrder = '/api/admin/spare_part/delivery_order/pageList' /**出库记录分页查询**/
export const exportPartDelivery = '/api/admin/spare_part/delivery_order/export_part_delivery' /**备件出库导出**/
export const queryPartDeliveryOrderLogs = '/api/admin/spare_part/delivery_order/queryPartDeliveryOrderLogs' /**备件出库日志记录**/
export const addPartDeliveryOrderLogs = '/api/admin/spare_part/delivery_order/save' /**备件出库**/
export const detelePartDeliveryOrderLogs = '/api/admin/spare_part/delivery_order/del' /**删除备件出库**/
export const personnelTotality = '/api/admin/kanban/personnel_totality' /**人员看板_左边总体情况**/
export const personnelPage = '/api/admin/kanban/personnel_page' /**人员看板_右边人员分页**/
export const dailyCheckTotality = '/api/admin/kanban/daily_check_totality' /**日常点检看板_左边总体情况**/
export const dailyCheckQuantity = '/api/admin/kanban/daily_check_quantity' /**日常点检看板_左边总体情况(新)**/
export const dailyCheckPage = '/api/admin/kanban/daily_check_page' /**日常点检看板_右边人员分页**/
export const dailyCheckQuantityPage = '/api/admin/kanban/daily_check_quantity_page' /**日常点检看板_右边人员分页(新)**/
export const planMaintainTotality = '/api/admin/kanban/planMaintain_totality' /**计划保养看板_左边总体情况**/
export const planMaintainPage = '/api/admin/kanban/planMaintain_page' /**计划保养看板_右边人员分页**/
export const sgkshPage = '/api/admin/kanban/sgksh_page' /**声光可视化看板**/
export const sgkshList = '/api/admin/kanban/sgksh_list' /**声光可视化看板**/
export const factoryRepair = '/api/admin/kanban/factory_repair' /**工厂级维修看板,当班人数、维修统计、正常异常图**/
export const factoryDev = '/api/admin/kanban/factory_dev' /**工厂级维修看板,设备状态**/
export const factoryAndon = '/api/admin/kanban/factory_andon' /**工厂级维修看板,安灯模块看板**/
export const getAllSysFaultCode = '/api/admin/sys_fault_code/pageList' /**系统故障代码分页查询**/
export const addSysFaultCode = '/api/admin/sys_fault_code/save' /**新增系统故障代码**/
export const editSysFaultCode = '/api/admin/sys_fault_code/edit' /**编辑系统故障代码**/
export const deleteSysFaultCode = '/api/admin/sys_fault_code/del' /**删除系统故障代码**/
export const sysFaultCodeTree = '/api/admin/sys_fault_code/sysFaultCodeTree' /**系统故障代码树状图**/
export const getSparePartPositionFcCode = '/api/admin/spare_part_position/pageList' /**库位分页查询**/
export const sparePartPositionList = '/api/admin/spare_part_position/list' /**查询所有库位**/
export const addSparePartPosition = '/api/admin/spare_part_position/save' /**新增库位**/
export const editSparePartPosition = '/api/admin/spare_part_position/edit' /**编辑库位**/
export const deleteSparePartPosition = '/api/admin/spare_part_position/del' /**删除库位**/
export const getAllEigDProblemInfo = '/api/admin/8d/problem/pageList' /**8D问题列表**/
export const getProblemPDF = '/api/admin/8d/problem/problem_pdf' /**PDF报表**/
export const addEigDProblemInfo = '/api/admin/8d/problem/save' /**新增8D问题**/
export const delEigDProblemInfo = '/api/admin/8d/problem/del' /**新增8D问题**/
export const getEigDProblemInfoProbCode = '/api/admin/8d/problem/detail/' /**8D问题详情**/
export const getStatusList = '/api/admin/8d/problem/status_list/' /**8D问题状态流转图**/
export const editEigProblemSummary = '/api/admin/8d/problem/summary/' /**8d问题总结**/
export const addEigDProblemTeam = '/api/admin/8d/team/create' /**新增8d团队**/
export const getEigDProblemTeamProbCode = '/api/admin/8d/team/list/' /**8D团队成员**/
export const addEigDContainment = '/api/admin/8d/containment/save' /**新增遏制措施**/
export const getEigDContainmentProbCode = '/api/admin/8d/containment/detail/' /**遏制措施详情**/
export const getEigDContainmentComplete = '/api/admin/8d/containment/complete/' /**遏制措施详情**/
export const addEigDProblemCauseItem = '/api/admin/8d/cause/analysis/save' /**新增原因分析项**/
export const getEigDProblemCauseProbCode = '/api/admin/8d/cause/analysis/detail/' /**原因分析详情**/
export const getEigDProblemCauseComplete = '/api/admin/8d/cause/analysis/complete/' /**原因分析完成**/
export const addCorrectiveItem = '/api/admin/8d/corrective/actions/corrective_item_save' /**新增纠正措施项**/
export const getCorrectiveItemComplete = '/api/admin/8d/corrective/actions/complete/' /**纠正措施完成**/
export const addVerifyItem = '/api/admin/8d/corrective/verify/verify_item_save' /**新增纠正措施验项证**/
export const getVerifyItemComplete = '/api/admin/8d/corrective/verify/complete/' /**纠正措施验证完成**/
export const addPrecaution = '/api/admin/8d/precaution/save' /**新增预防措施**/
export const getPrecautionProbCode = '/api/admin/8d/precaution/detail/' /**预防措施详情**/
export const getPrecautionComplete = '/api/admin/8d/precaution/complete/' /**预防措施完成**/
export const uplodFiles = '/api/upload/files' /**上传文件**/
export const eigDuplodFiles = '/api/admin/problem/upload/files' /**8D文件上传**/
export const deleteDuplodFiles = '/api/admin/problem/upload/del' /**删除文件**/
export const addPersonLiable = '/api/admin/8d/problem/add_person_liable/' /**8D问题添加责任人**/
export const auditProblem = '/api/admin/8d/problem/audit/' /**8D问题审核**/
export const getAllSparePartWaring = '/api/admin/spare_part/waring/pageList' /**备件提醒列表**/
export const sparePartWaringList = '/api/admin/spare_part/waring/sparePartWaringList' /**查询所有备件提醒**/
export const sparePartWaringPurchase = '/api/admin/spare_part/waring/purchase' /**采购**/
export const sparePartWaringPurchaseComplete = '/api/admin/spare_part/waring/purchase_complete' /**采购完成**/
export const getAllStock = '/api/admin/spare_part_stock/pageList' /**库存分页查询**/
export const allotStock = '/api/admin/spare_part_stock/allot_stock' /**库存调拨**/
export const exportSparePartStock = '/api/admin/spare_part_stock/export_spare_part_stock' /**库存导出**/
export const faultCodeThreeTree = '/api/admin/sys_fault_code/tree' /**故障代码三级联动**/
export const getDeviceOpcConfigList = '/api/base/device_opc_config/getDeviceOpcConfigList' /**根据设备编号查询OPC信息**/
export const saveDeviceOpcConfig = '/api/base/device_opc_config/save' /**新增、编辑OPC信息**/
export const deteleDeviceOpcConfig = '/api/base/device_opc_config/del' /**删除OPC信息**/
export const SysOperationLogList = '/api/sys_operation_log/list' /**查询日志记录**/
export const toolingInfoLogList = '/api/sys_operation_log/toolingInfoLogList' /**查询工装日志记录**/
export const sparePartInfoLogList = '/api/sys_operation_log/sparePartInfoLogList' /**查询备件日志记录**/
export const AndonMailPushConfigList = '/api/andon_mail_push_config/AndonMailPushConfigList' /**查询邮件通知人**/
export const addAndonMailPushConfig = '/api/andon_mail_push_config/save' /**新增邮件通知人**/
export const editAndonMailPushConfig = '/api/andon_mail_push_config/edit' /**修改邮件通知人**/
export const delAndonMailPushConfig = '/api/andon_mail_push_config/del' /**删除邮件通知人**/
export const userMailList = '/api/admin/user/userMailList' /**查询有邮件的用户**/
export const sysOperationLogList = '/api/sys_operation_log/list' /**查询日志记录**/
export const getTrainingNotRespList = '/api/admin/training/getTrainingNotRespList' /**培训通知详情**/
export const getAllLayeredCycle = '/api/base/audit_layered_cycle/pageList' /**审核周期分页查询**/
export const addLayeredCycle = '/api/base/audit_layered_cycle/save' /**新增审核周期**/
export const editLayeredCycle = '/api/base/audit_layered_cycle/edit' /**编辑审核周期**/
export const deleteLayeredCycle = '/api/base/audit_layered_cycle/del' /**删除审核周期**/
export const getAllLayeredLevel = '/api/base/audit_layered_level/pageList' /**审核层级分页查询**/
export const LayeredLevelList = '/api/base/audit_layered_level/list' /**审核层级分页查询**/
export const addLayeredLevel = '/api/base/audit_layered_level/save' /**新增审核层级**/
export const editLayeredLevel = '/api/base/audit_layered_level/edit' /**编辑审核层级**/
export const deleteLayeredLevel = '/api/base/audit_layered_level/del' /**删除审核层级**/
export const getAllLayeredFrequency = '/api/base/audit_layered_frequency/pageList' /**审核频率分页查询**/
export const addLayeredFrequency = '/api/base/audit_layered_frequency/save' /**新增审核频率**/
export const editLayeredFrequency = '/api/base/audit_layered_frequency/edit' /**编辑审核频率**/
export const deleteLayeredFrequency = '/api/base/audit_layered_frequency/del' /**删除审核频率**/
export const getLayeredFrequencyLfId = '/api/base/audit_layered_frequency/getLayeredFrequencyLfId' /**根据主键Id查询审核频率详情**/
export const getAllLayeredProblem = '/api/base/audit_layered_problem/pageList' /**审核问题项分页查询**/
export const addLayeredProblem = '/api/base/audit_layered_problem/save' /**新增审核问题项**/
export const editLayeredProblem = '/api/base/audit_layered_problem/edit' /**编辑审核问题项**/
export const deleteLayeredProblem = '/api/base/audit_layered_problem/del' /**删除审核问题项**/
export const getLayeredProblemLpId = '/api/base/audit_layered_problem/getLayeredProblemLpId' /**根据主键id查询问题项详情**/
export const getAllLayeredOrder = '/api/base/audit_layered_order/pageList' /**审核工单分页查询**/
export const getLayerdOrderItem = '/api/base/audit_layered_order_item/getLayerdOrderItem' /**根据工单编号查询工单详情**/
export const layeredOrderNotProblemList = '/api/base/audit_layered_order_item/pageList' /**后台Not问题清单分页查询**/
export const exportLayeredNotOrder = '/api/base/audit_layered_order_item/export_layered_not_order' /**问题清单导出**/
export const deleteLayeredOrder = '/api/base/audit_layered_order/deleteLayeredOrder' /**删除审核工单以及工单详情**/
export const getAllLayeredProblemType = '/api/base/audit_layered_problem_type/pageList' /**问题分类分页查询**/
export const addLayeredProblemType = '/api/base/audit_layered_problem_type/save' /**新增问题分类**/
export const editLayeredProblemType = '/api/base/audit_layered_problem_type/edit' /**编辑问题分类**/
export const deleteLayeredProblemType = '/api/base/audit_layered_problem_type/del' /**删除问题分类**/
export const problemTypeTitleAll = '/api/base/audit_layered_problem_type/problemTypeTitleAll' /**问题分类树状图**/
export const getAllLayeredProblemTitle = '/api/base/audit_layered_problem_title/pageList' /**问题标题分页查询**/
export const addLayeredProblemTitle = '/api/base/audit_layered_problem_title/save' /**新增问题标题**/
export const editLayeredProblemTitle = '/api/base/audit_layered_problem_title/edit' /**编辑问题标题**/
export const deleteLayeredProblemTitle = '/api/base/audit_layered_problem_title/del' /**删除问题标题**/
export const getLayeredTrackingProblemLoiId = '/api/base/audit_layered_tracking_problem/getLayeredTrackingProblemLoiId' /**根据工单Id,工单详情Id查询**/
export const editLayeredTrackingProblem = '/api/base/audit_layered_tracking_problem/edit' /**编辑问题清单**/
export const factorylineState = '/api/admin/kanban/device_line_status' /**工厂级看板,产线状态**/
export const echartsStatistics = '/api/admin/kanban/user_device_plan_status' /**工厂级看板,签到人数,设备状态,保养统计**/
export const andonStateecharts = '/api/admin/kanban/andon_status_type' /**工厂级看板,安灯状态，安灯类型**/
export const shoplayout = '/api/admin/kanban/factory_layout' /**工厂级看板,车间布局图**/
export const personnelFacTotality = '/api/admin/kanban/personnel_fac_totality' /**工厂级看板,右侧实时维修单**/
export const getAllFourM = '/api/admin/gm_four_m/pageList' /**4M分页查询**/
export const exportFourM = '/api/admin/gm_four_m/export_four_m' /**4M导出**/
export const getAllGmMessage = '/api/admin/gm_message/pageList' /**消息推送分页查询**/
export const addMessage = '/api/admin/gm_message/save' /**新增消息推送**/
export const editMessage = '/api/admin/gm_message/edit' /**新增消息推送**/
export const financeListInfo = '/api/admin/gm_lp_rated_val/pageList' /**产线、产品号,标准节拍、标准工时分页查询**/
export const AddfinanceInfo = '/api/admin/gm_lp_rated_val/save' /**新增产线、产品号,标准节拍、标准工时**/
export const UpdfinanceInfo = '/api/admin/gm_lp_rated_val/edit' /**编辑产线、产品号,标准节拍、标准工时**/
export const DelfinanceInfo = '/api/admin/gm_lp_rated_val/del' /**删除产线、产品号,标准节拍、标准工时**/
export const getOeeGoal = '/api/admin/gm_oee_target/pageList' /**oee目标分页查询**/
export const addOeeGoal = '/api/admin/gm_oee_target/save' /**新增oee目标**/
export const editOeeGoal = '/api/admin/gm_oee_target/edit' /**编辑oee目标**/
export const delOeeGoal = '/api/admin/gm_oee_target/del' /**删除oee目标**/
export const getDeviceOpcOee = '/api/admin/report_form/getDeviceOpcOee' /**根据工厂编码查询Oee**/
export const exportDeviceStatistics = '/api/admin/report_form/export_device_statistics' /**设备-统计报表导出**/
export const exportPersonnelStatistics = '/api/admin/report_form/export_personnel_statistics' /**人员-统计报表导出**/
export const exportDeviceOpcOee = '/api/admin/report_form/export_device_opc_oee' /**oee-报表导出**/
export const getDeviceRunStatusChange = '/api/admin/device_run_status_change/pageList' /**后台设备运行状态变化分页查询**/
export const getPurchaseItemPageList = '/api/admin/spare_part/purchase_order/sparePartPurchaseItemPageList' /**入库项分页查询**/
export const exportSparePartPurchaseItem = '/api/admin/spare_part/purchase_order/export_spare_part_purchase_item' /**备件入库Item项导出**/
export const getDeliveryItemPageList = '/api/admin/spare_part/delivery_order/sparePartDeliveryItemPageList' /**出库项分页查询**/
export const exportSparePartDeliveryItem = '/api/admin/spare_part/delivery_order/export_spare_part_delivery_item' /**备件出库Item项导出**/
export const exportDeviceRunStatusChange = '/api/admin/device_run_status_change/export_device_run_status_change' /**设备运行状态变化导出**/
export const getAndonOrderDetail = '/api/andon_order/getAndonOrderDetail' /**根据安灯编码查询**/
export const getBranch = '/api/admin/dept/pageList' /**部门分页查询**/
export const getAllBranch = '/api/admin/dept/list' /**全部部门查询**/
export const addBranch = '/api/admin/dept/save' /**新增部门**/
export const editBranch = '/api/admin/dept/edit' /**编辑部门**/
export const delBranch = '/api/admin/dept/del' /**删除部门**/
export const getDepart = '/api/admin/section_office/pageList' /**科室分页查询**/
export const addDepart = '/api/admin/section_office/save' /**新增科室**/
export const editDepart = '/api/admin/section_office/edit' /**编辑科室**/
export const delDepart = '/api/admin/section_office/del' /**删除科室**/
export const getStaff = '/api/admin/section_office/sectionOfficePageList' /**科室下员工分页查询**/
export const addStaff = '/api/admin/user/editUserSsoId' /**新增科室下员工**/
export const editStaff = '/api/admin/section_office/editLiableUser' /**编辑科室下员工**/
export const delStaff = '/api/admin/user/deleteUserSsoId' /**删除科室下员工**/
export const getNoStaff = '/api/admin/user/userDeptList' /**未分配科室的员工分页查询**/
export const getSuggest = '/api/admin/user_propose/pageList' /**合理化建议分页查询**/
export const getBranchAndDep = '/api/admin/depart/deptSectionOffice' /**部门科室查询**/
export const sectionOfficeTemplate = '/api/admin/section_office/sectionOfficeTemplate' /**科室导入模板**/
export const sectionOfficeImport = '/api/admin/section_office/sectionOfficeImport' /**批量导入科室**/
export const getDeptSectionLiableUser = '/api/admin/section_office/getDeptSectionLiableUser' /**根据条件查询科室班组长**/
export const getAndonOperationList = '/api/admin/andon_scanning_code/getAndonOperationList' /**安灯扫码操作类型**/
export const getAndonScanningCodeParam = '/api/admin/andon_scanning_code/getAndonScanningCodeParam' /**查询安灯扫码操作类型**/
export const saveAndonScanningCodeParam = '/api/admin/andon_scanning_code/saveAndonScanningCodeParam' /**更新安灯扫码操作类型**/
export const andonRestConfigPageList = '/api/admin/andon_rest_config/pageList' /**吃饭休息配置分页查询**/
export const andonRestConfigSave = '/api/admin/andon_rest_config/save' /**新增吃饭休息配置**/
export const andonRestConfigEdit = '/api/admin/andon_rest_config/edit' /**编辑吃饭休息配置**/
export const andonRestConfigDel = '/api/admin/andon_rest_config/del' /**删除吃饭休息配置**/
export const andonRestConfigToggleActive = '/api/admin/andon_rest_config/toggleActive' /**启用禁用吃饭休息配置**/
export const andonRestConfigCancelToday = '/api/admin/andon_rest_config/cancelToday' /**临时取消当天配置**/
export const andonRestConfigGetCancelDates = '/api/admin/andon_rest_config/getCancelDates' /**获取取消日期列表**/
export const andonRestConfigCancelDate = '/api/admin/andon_rest_config/cancelDate' /**取消单个日期**/
export const andonRestConfigCancelDateRange = '/api/admin/andon_rest_config/cancelDateRange' /**取消日期范围**/
export const andonRestConfigUncancelDate = '/api/admin/andon_rest_config/uncancelDate' /**恢复取消日期**/
export const andonRestConfigLineCancelPageList = '/api/admin/andon_rest_config/lineCancelPageList' /**产线取消记录分页**/
export const andonRestConfigBatchCancelLines = '/api/admin/andon_rest_config/batchCancelLines' /**批量取消产线**/
export const andonRestConfigDeleteLineCancel = '/api/admin/andon_rest_config/deleteLineCancel' /**删除产线取消记录**/
export const andonRestConfigTemplate = '/api/admin/andon_rest_config/template' /**下载导入模板**/
export const andonRestConfigImport = '/api/admin/andon_rest_config/import' /**批量导入**/
export const andonRestConfigManualTrigger = '/api/admin/andon_rest_config/manualTrigger' /**手动触发换型**/
export const andonRestConfigLines = '/api/admin/andon_rest_config/lines' /**查询工厂+车间下的产线**/
export const andonRestConfigExport = '/api/admin/andon_rest_config/export' /**导出配置列表**/
export default {
    getDeptSectionLiableUser,
    sectionOfficeImport,
    sectionOfficeTemplate,
    getBranchAndDep,
    getSuggest,
    getStaff,
    addStaff,
    editStaff,
    delStaff,
    getNoStaff,
    getBranch,
    getAllBranch,
    addBranch,
    editBranch,
    delBranch,
    getDepart,
    addDepart,
    editDepart,
    delDepart,
    Login,
    SearchUser,
    SearchRole,
    editUser,
    getAndonTypeRuleAuth,
    addAndonTypeRuleAuth,
    delAndonTypeRuleAuth,
    editUserPassword,
    getAllUserList,
    depart_tree,
    listRole,
    departTree,
    userSave,
    userRole,
    deleteUserRole,
    getUserByRole,
    addItemCheekByPmiId,
    addItemByPmiId,
    getUserItemByPmiId,
    getUserItemCheckByPmiId,
    addUserRole,
    deleteSave,
    userReset,
    getAllRole,
    addRole,
    editRole,
    deleteRole,
    getAllRoleAuth,
    getAllAuth,
    editUserRole,
    getAllShift,
    shiftList,
    addShift,
    editShift,
    delShift,
    getAllFactory,
    getWorkShopList,
    getSectionList,
    getLineList,
    lineList,
    addFactory,
    addWorkShop,
    addsection,
    addline,
    editFactory,
    editWorkShop,
    editsection,
    editline,
    delWorkShop,
    delSection,
    delLine,
    getAllAndonRule,
    deteleAndonRule,
    getAndonRule,
    getAllAndonOrder,
    andonOrderList,
    editAndonOrder,
    deleteAndonOrder,
    getAndonOrderLog,
    getAndonContent,
    addAndonContent,
    editAndonContent,
    deleteAndonContent,
    andonContentList,
    getAlldevice,
    addDevice,
    editDevice,
    deleteDevice,
    getAllDailyCheckOrder,
    deleteDailyCheckOrder,
    getAndonNotifyRule,
    deleteAndonRuleRole,
    addAndonRuleRole,
    addAndonRule,
    editAndonRule,
    getDeviceFileDevCode,
    addDeviceFile,
    editDeviceFile,
    deleteDeviceFile,
    getDailyCheckItemDevCode,
    addDailyCheckItem,
    editDailyCheckItem,
    deleteDailyCheckItem,
    getPlanMantainItemDevCode,
    addPlanMantainItem,
    editPlanMantainItem,
    deletePlanMantainItem,
    getPmiRespTypes,
    getPlanMaintainOrder,
    addPlanMaintainOrder,
    editPlanMaintainOrder,
    delPlanMaintainOrder,
    planMaintainOrderList,
    getPlanMaintainOrderPmoNo,
    getPlanMaintainLogPmoNo,
    getAndonOrderLogAndonCode,
    getDacklogDcoId,
    getAllAndonType,
    getRoleList,
    addAndonContentInsert,
    delAndonContent,
    getAndonContentOne,
    getAndonRuleNext,
    getPlanMainOrderItemPmoNo,
    getDeviceOperationLogDevCode,
    exportRole,
    exportUser,
    exportShift,
    exportDepart,
    exportDevice,
    exportDailyCheckOrder,
    exportPlanMaintainOrder,
    exportAndonRule,
    exportAndonOrder,
    exportAndonContent,
    getAndonOrderCheckAndonCode,
    getAndonRuleAcCode,
    getAndonOrderResp,
    queryUserRoles,
    changeFactoryLogin,
    queryUserFactorys,
    editUserInfo,
    findUserById,
    findUserByAccount,
    userTemplate,
    userImport,
    userTestExport,
    deviceTemplate,
    deviceImport,
    planMaintainTemplate,
    planMaintainImport,
    dailyCheckItemTemplate,
    dailyCheckItemImport,
    enumTypePageList,
    enumTypelist,
    addEnumType,
    editEnumType,
    delEnumType,
    queryDevCode,
    getAllRepairExp,
    getRepairExpDevCode,
    addRepairExp,
    editRepairExp,
    deleteRepairExp,
    getAllFaultCode,
    getFaultCodeDevCode,
    addFaultCode,
    editFaultCode,
    deleteFaultCode,
    faultCodeTree,
    getAndonRuleTrigger,
    deviceInfoList,
    getDeviceInfoDevCode,
    getAllToolingClassify,
    toolingClassifyList,
    addToolingClassify,
    editToolingClassify,
    deleteToolingClassify,
    getToolingClassifyList,
    toolingTemplate,
    toolingImport,
    exportToolingInfo,
    getAllToolingInfo,
    toolingInfoList,
    addToolingInfo,
    editToolingInfo,
    deleteToolingInfo,
    getToolingCode,
    unitList,
    addToolingUse,
    getUseRecordToolingTiId,
    exportToolingUseRecord,
    addToolingRevert,
    getRevertRecordToolingTiId,
    exportRevertRecordTooling,
    getAllPartClassify,
    partClassifyList,
    addPartClassify,
    editPartClassify,
    deletePartClassify,
    getAllSparePart,
    sparePartInfoList,
    queryByPartInfoSpCode,
    addSparePartInfo,
    editSparePartInfo,
    deleteSparePartInfo,
    getSparePartInfoSpCode,
    sparePartInfoTemplate,
    sparePartInfoImport,
    exportSparePartInfo,
    getAllPartStoreHouse,
    partStoreHouseList,
    addPartStoreHouse,
    editPartStoreHouse,
    deletePartStoreHouse,
    exportPartStoreHouse,
    getAllPartStock,
    getAllPartStockStrCode,
    partStockList,
    queryAmount,
    sparePartLibrary,
    addPartStock,
    editPartStock,
    deletePartStock,
    userList,
    tooLingClassifyTree,
    partClassifyTree,
    getAllPartPurchaseOrder,
    addPartPurchaseOrder,
    deletePartPurchaseOrder,
    queryPartInfoLogs,
    exportPartPurchase,
    getAllPartDeliveryOrder,
    exportPartDelivery,
    queryPartDeliveryOrderLogs,
    addPartDeliveryOrderLogs,
    detelePartDeliveryOrderLogs,
    personnelTotality,
    personnelPage,
    dailyCheckTotality,
    dailyCheckQuantity,
    dailyCheckPage,
    dailyCheckQuantityPage,
    planMaintainTotality,
    planMaintainPage,
    sgkshPage,
    sgkshList,
    factoryRepair,
    factoryDev,
    factoryAndon,
    getAllSysFaultCode,
    addSysFaultCode,
    editSysFaultCode,
    deleteSysFaultCode,
    sysFaultCodeTree,
    getSparePartPositionFcCode,
    sparePartPositionList,
    addSparePartPosition,
    editSparePartPosition,
    deleteSparePartPosition,
    getAllEigDProblemInfo,
    getProblemPDF,
    addEigDProblemInfo,
    delEigDProblemInfo,
    getEigDProblemInfoProbCode,
    getStatusList,
    editEigProblemSummary,
    addEigDProblemTeam,
    getEigDProblemTeamProbCode,
    addEigDContainment,
    getEigDContainmentProbCode,
    getEigDContainmentComplete,
    addEigDProblemCauseItem,
    getEigDProblemCauseProbCode,
    getEigDProblemCauseComplete,
    addCorrectiveItem,
    getCorrectiveItemComplete,
    addVerifyItem,
    getVerifyItemComplete,
    addPrecaution,
    getPrecautionProbCode,
    getPrecautionComplete,
    uplodFiles,
    eigDuplodFiles,
    deleteDuplodFiles,
    addPersonLiable,
    auditProblem,
    getAllSparePartWaring,
    sparePartWaringList,
    sparePartWaringPurchase,
    sparePartWaringPurchaseComplete,
    getAllStock,
    allotStock,
    exportSparePartStock,
    faultCodeThreeTree,
    getDeviceOpcConfigList,
    saveDeviceOpcConfig,
    deteleDeviceOpcConfig,
    SysOperationLogList,
    toolingInfoLogList,
    sparePartInfoLogList,
    AndonMailPushConfigList,
    addAndonMailPushConfig,
    editAndonMailPushConfig,
    delAndonMailPushConfig,
    userMailList,
    sysOperationLogList,
    getTrainingNotRespList,
    getAllLayeredCycle,
    addLayeredCycle,
    editLayeredCycle,
    deleteLayeredCycle,
    getAllLayeredLevel,
    LayeredLevelList,
    addLayeredLevel,
    editLayeredLevel,
    deleteLayeredLevel,
    getAllLayeredFrequency,
    addLayeredFrequency,
    editLayeredFrequency,
    deleteLayeredFrequency,
    getLayeredFrequencyLfId,
    getAllLayeredProblem,
    addLayeredProblem,
    editLayeredProblem,
    deleteLayeredProblem,
    getLayeredProblemLpId,
    getAllLayeredOrder,
    getLayerdOrderItem,
    layeredOrderNotProblemList,
    exportLayeredNotOrder,
    deleteLayeredOrder,
    getAllLayeredProblemType,
    addLayeredProblemType,
    editLayeredProblemType,
    deleteLayeredProblemType,
    problemTypeTitleAll,
    getAllLayeredProblemTitle,
    addLayeredProblemTitle,
    editLayeredProblemTitle,
    deleteLayeredProblemTitle,
    getLayeredTrackingProblemLoiId,
    editLayeredTrackingProblem,
    factorylineState,
    echartsStatistics,
    andonStateecharts,
    shoplayout,
    personnelFacTotality,
    getAllFourM,
    exportFourM,
    getAllGmMessage,
    addMessage,
    editMessage,
    financeListInfo,
    AddfinanceInfo,
    UpdfinanceInfo,
    DelfinanceInfo,
    getOeeGoal,
    addOeeGoal,
    editOeeGoal,
    delOeeGoal,
    getDeviceOpcOee,
    exportDeviceStatistics,
    exportPersonnelStatistics,
    exportDeviceOpcOee,
    getDeviceRunStatusChange,
    getPurchaseItemPageList,
    exportSparePartPurchaseItem,
    getDeliveryItemPageList,
    exportSparePartDeliveryItem,
    exportDeviceRunStatusChange,
    getAndonOrderDetail,
    getAndonOperationList,
    getAndonScanningCodeParam,
    saveAndonScanningCodeParam,
    andonRestConfigPageList,
    andonRestConfigSave,
    andonRestConfigEdit,
    andonRestConfigDel,
    andonRestConfigToggleActive,
    andonRestConfigCancelToday,
    andonRestConfigGetCancelDates,
    andonRestConfigCancelDate,
    andonRestConfigCancelDateRange,
    andonRestConfigUncancelDate,
    andonRestConfigLineCancelPageList,
    andonRestConfigBatchCancelLines,
    andonRestConfigDeleteLineCancel,
    andonRestConfigTemplate,
    andonRestConfigImport,
    andonRestConfigManualTrigger,
    andonRestConfigLines,
    andonRestConfigExport,
    validatePassword,
    pwdStatus,
    pwdPolicy
}
